import { endPoints, requestType } from "../lib/variable";
import Api from "./index";

const saveCard = (payload) => {
  return Api(endPoints.cardSave, payload, requestType.POST);
};
const removeCard = (payload) => {
  return Api(endPoints.cardRemove, payload, requestType.POST);
};
const getAllCard = (id) => {
  return Api(`${endPoints.fetchCards}/${id}`, null, requestType.GET);
};

const userPayment = (payload) => {
  return Api(endPoints.userPayment, payload, requestType.POST);
};

const userCheckEligibility = (payload) => {
  return Api(endPoints.userCheckEligibility, payload, requestType.POST);
};

const cancelSubscription = (id) => {
  return Api(`${endPoints.cancelSubscription}/${id}`, null, requestType.DELETE);
};

export {
  saveCard,
  getAllCard,
  removeCard,
  userPayment,
  userCheckEligibility,
  cancelSubscription,
};
